import React from 'react';
import { graphql } from 'gatsby';
import { Footer as FooterLG } from '@lanl-web/lanl-components';
import FooterData from '../../slice-data/footer.json';

const Footer = ({}) => {
  const { result } = FooterData;

  return (
    <React.Fragment>
      <FooterLG footerData={result?.data?.directus?.lg_footer ?? []} />
    </React.Fragment>
  );
};

export default Footer;
